import { buildSoftwareInstructions } from '#/store/hooks/useForms/Import/fields/Instructions/software'
import { buildTemplateInstructions } from '#/store/hooks/useForms/Import/fields/Instructions/template'
import { ImportInstructionsConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

interface IParams {
  instructions?: ImportInstructionsConfig
  format_file: string
  fileURL?: string
  name: string
  spreadsheetType?: string
}

const resolveInstructions = (props: IParams) => {
  const { fileURL, format_file, instructions, spreadsheetType } = props

  if (instructions?.software) {
    return buildSoftwareInstructions({ instructions, spreadsheetType })
  }

  return buildTemplateInstructions({ fileURL, format_file })
}

export const buildInstructionsField = (props: IParams) => {
  const { name, spreadsheetType } = props

  return {
    disabled: true,
    name,
    rules: spreadsheetType
      ? { hidden_unless: { field: 'spreadsheet-type', value: spreadsheetType } }
      : undefined,
    type: 'list',
    value: resolveInstructions(props),
  }
}
